import React, { FC } from 'react';
import ReplayIcon from '@material-ui/icons/Replay';
import { Alert } from '@material-ui/lab';

import { EditButton } from '..';
import Confirmation from '../Confirmation';
import { useClearPassword } from '~/hooks/apiIdentity';
import { useApiIdentityTranslate } from '.';

interface Props {
  identityId: string | undefined;
  className?: string;
  disabled?: boolean;
}

const ClearPasswordAction: FC<Props> = (props) => {
  const { className, identityId, disabled } = props;
  const t = useApiIdentityTranslate();

  const clearPasswordMutation = useClearPassword();
  const handleClear = () => {
    if (identityId) {
      return clearPasswordMutation.mutateAsync(identityId);
    }
  };

  return (
    <Confirmation
      onConfirm={handleClear}
      confirmButtonProps={{ loading: clearPasswordMutation.isLoading }}
      confirmationSettings={{
        variant: 'modal',
        modal: { content: <Alert severity='warning'>{t('clearPasswordWarning')}</Alert> },
      }}
    >
      <EditButton
        className={className}
        label={t('clearPassword')}
        icon={<ReplayIcon />}
        disabled={disabled}
        red
      />
    </Confirmation>
  );
};

export default ClearPasswordAction;
